export default {
  mounted () {
    let rects = this.$el.getClientRects()

    this.size = {
      width: rects[0] ? rects[0].width : 0,
      height: rects[0] ? rects[0].height : 0
    }
    const resizeObserver = new ResizeObserver(entries => {
      entries.forEach((entry)=>{
        // console.log("contentRect",entry.contentRect)
        this.size = {
          width: entry.contentRect.width,
          height: entry.contentRect.height
        }
      })
    });
    resizeObserver.observe(this.$el)

  },
  data(){
    return {
      size: {width: 1, height: 1}
    }
  },
}